'use client'

import { type ComponentProps, useMemo, useSyncExternalStore } from 'react'
import { ButtonCTA } from '~/components/ButtonCTA'
import { useTrackingUrl } from '~/hooks/use-tracking-url'
import { buildScheduleRedirectUrl, PAID_MEDIA_CALENDLY_URL, SCHEDULE_TRACKING_OPTIONS } from '~/utils/ctas'
import { loadLeadMagnetQualification } from '~/utils/lead-magnet-qualification'

const emptySubscribe = () => () => {}

type Props = Omit<ComponentProps<typeof ButtonCTA>, 'href'> & {
  segmentElement: string
}

export const LeadMagnetScheduleCTA = ({ segmentElement, children, ...props }: Props) => {
  const mounted = useSyncExternalStore(
    emptySubscribe,
    () => true,
    () => false
  )
  const isQualified = useMemo(() => mounted && loadLeadMagnetQualification(), [mounted])
  const href = useTrackingUrl(buildScheduleRedirectUrl(PAID_MEDIA_CALENDLY_URL, {}), SCHEDULE_TRACKING_OPTIONS)

  if (!isQualified) return null

  return (
    <ButtonCTA href={href} segmentElement={segmentElement} {...props}>
      {children}
    </ButtonCTA>
  )
}
